import React, { ReactNode } from 'react';

interface IProps {
    children: ReactNode,
    withBottomBlue?: boolean,
    appendClass?: string
}

const FormCard = ({ children, withBottomBlue = false, appendClass = '' }: IProps) => {
    const cardClass =  `info-title box-shaddow box-padding mb-5 ${withBottomBlue ? 'border-btm-blue' : ''} ${appendClass}`
    return <div className={cardClass}>
        {children}
    </div>
}

export default FormCard;